import { createContext } from "react";
import type { PortableTextComponents } from "@portabletext/react";

type CustomComponentsCtxValue = {
  customComponents: Partial<PortableTextComponents>;
};

/**
 * Hands `BlockContent`'s Portable Text components down to blocks that render
 * Portable Text of their own (e.g. `Branch`, `Quote`), so nested content looks
 * the same as the top level. It can't simply be imported: the components
 * depend on `BlockContent`'s `textColor` prop, and they include those very
 * blocks, so importing them back would create an import cycle.
 */
const CustomComponentsCtx = createContext<CustomComponentsCtxValue | null>(
  null,
);

export default CustomComponentsCtx;
